
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import AllInclusiveIcon from "@mui/icons-material/AllInclusive";
import HistoryIcon from "@mui/icons-material/History";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import { Alert, Avatar, Button, Dialog, DialogActions, DialogContent, DialogTitle, List, ListItem, ListItemAvatar, ListItemText, Skeleton } from "@mui/material";
import axios from "axios";
import moment from "moment";
import * as React from "react";
import { Config } from "../../config/config";
import { Helpers } from "../../utils/helpers";
import { PopupMessage } from "../../utils/message";
import { DefaultProps } from "../LayoutWrapper";

interface State {
    dialogVisible: boolean;
    loaded: boolean;
    list: any[];
}

interface Props extends DefaultProps {
    playerData: any;
    type: "ban" | "mute";
    dataLoaded: boolean;
}

export class PunishmentHistory extends React.Component<Props, State> {

    constructor(props) {
        super(props);

        this.state = {
            dialogVisible: false,
            loaded: false,
            list: new Array(2).fill(null),
        };
    }

    showDialog() {
        this.setState({
            dialogVisible: true,
        }, () => {
            this.fetchData();
        })
    }

    hideDialog() {
        this.setState({
            dialogVisible: false,
            loaded: false,
            list: new Array(2).fill(null),
        })
    }

    fetchData() {
        axios.get(`${Config.getInstance.apiUrl}/api/user/${this.props.playerData.id}/punishment_history/${this.props.type}`, {
            headers: {
                Authorization: Helpers.getSessionId(),
            },
        }).then(response => {
            this.setState({
                loaded: true,
                list: response.data.history,
            });
        }).catch(() => {
            PopupMessage.error(`Couldn't load ${this.props.type} history`);

            return this.setState({
                loaded: true,
            });
        });
    }

    /**
     * Render avatar for list item
     *
     * @param {string} type
     * @returns
     * @memberof PunishmentHistory
     */
    renderItemAvatar(type: string) {
        switch (type) {
            case "1":
                return <Avatar sx={{ bgcolor: "#FFEB3B" }}>
                    <AccessTimeIcon/>
                </Avatar>;
            case "2":
                return <Avatar sx={{ bgcolor: "#D32F2F" }}>
                    <AllInclusiveIcon/>
                </Avatar>
            case "5":
                return <Avatar sx={{ bgcolor: "#388E3C" }}>
                    <LockOpenIcon/>
                </Avatar>
            default:
                null;
        }
    }

    /**
     * Render primary text for list item
     *
     * @param {*} item
     * @returns
     * @memberof PunishmentHistory
     */
    renderPrimaryText(item) {
        switch (item.action_type) {
            case "1":
                return `Temporary ${this.props.type === "ban" ? "banned" : "muted"}`
            case "2":
                return `Permanently ${this.props.type === "ban" ? "banned" : "muted"}`
            case "5":
                return this.props.type === "ban" ? "Unbanned" : "Unmuted"
            default:
                null;
        }
    }

    /**
     * Render secondary text for list item
     *
     * @param {*} item
     * @returns
     * @memberof PunishmentHistory
     */
    renderSecondaryText(item) {
        let reason: any = null;
        let expire: any = null;

        if (item.reason && item.reason.length > 0) {
            reason = <React.Fragment>
                Reason: {item.reason}<br/>
            </React.Fragment>;
        }

        if (item.expire) {
            expire = <React.Fragment>
                Expire: {moment(item.expire).format("DD.MM.YYYY HH:MM")}<br/>
            </React.Fragment>;
        }

        return <span style={{ color: "rgb(131, 131, 131)" }}>
            {expire}
            {reason}
            Issued at: {moment(item.created_at).format("DD.MM.YYYY HH:MM")}
        </span>
    }

    renderListItem = (item) => {
        if (!this.state.loaded) {
            return <ListItem>
                <ListItemAvatar>
                    <Skeleton variant="circular" width={40} height={40} />
                </ListItemAvatar>
                <ListItemText
                    primary={<Skeleton width="60%" height={20}/>}
                    secondary={<Skeleton width="10%" height={20}/>}
                />
            </ListItem>
        }

        return <ListItem>
            <ListItemAvatar>
                {this.renderItemAvatar(item.action_type)}
            </ListItemAvatar>
            <ListItemText
                primary={this.renderPrimaryText(item)}
                secondary={this.renderSecondaryText(item)}
            />
        </ListItem>
    }

    render() {
        if (!this.props.dataLoaded) {
            return null;
        }

        return <React.Fragment>
            <HistoryIcon style={{ marginLeft: 10, cursor: "pointer", fontSize: 16 }} onClick={() => this.showDialog()}/>

            <Dialog
                open={this.state.dialogVisible}
                onClose={() => this.hideDialog()}
                fullWidth={true}
                maxWidth="sm"
            >
                <DialogTitle>{Helpers.capitalizeFirstLetter(this.props.type)} history</DialogTitle>

                <DialogContent dividers style={{ padding: 0 }}>
                    {this.state.loaded && this.state.list.length === 0 && <div style={{ padding: "10px 15px 0px 15px" }}>
                        <Alert severity="info">No {this.props.type} history found</Alert>
                    </div>}

                    <List sx={{ width: "100%" }}>
                        {this.state.list.map(this.renderListItem)}
                    </List>
                </DialogContent>

                <DialogActions>
                    <Button disableElevation onClick={() => this.hideDialog()} color="primary" variant="contained">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    }
}
